module.exports = __webpack_public_path__ + "img/3.57333b4c.png";